import { useMemo } from 'react';
import Fields from '../Fields';
import { useAuth } from '../../../../utils/Auth';
import FileInput from '../../../FileInput';
import { useFileUpload } from '../../../../utils/hooks/useFileUpload';
import FilesList from '../../../FilesList';
import styles from './Tracker.module.css';

export default function Tracker(props) {
    const { reference } = props;
    const { qr_data } = useAuth();

    const acceptableFileTypes = ['image/png', 'image/webp', 'image/gif', 'image/jpeg', 'image/jpg', 'application/pdf'];

    const fileHelpers = useFileUpload({ acceptableFileTypes, type: 'tracker', fileHandleType: 'qr_files' });
    const { handleFileSelected, filesToDisplay, error } = fileHelpers;

    const fields = useMemo(() => {
        const baseFields = qr_data?.data?.tracker?.fields?.length
            ? qr_data.data.tracker.fields
            : [{ id: 'date', name: 'Timestamp', archived: false, show: true, type: 'date', required: true }];

        const filteredFields = baseFields.filter(field => field.type !== 'date');

        return filteredFields.sort((a,b) => a.archived - b.archived);
    });

    // Store the original fields when component first mounts with data
    const originalFields = useMemo(() => {
        if (reference === 'new') return [];
        const baseFields = qr_data?.data?.tracker?.fields?.length
            ? qr_data.data.tracker.fields
            : [];
        return baseFields.filter(field => field.type !== 'date');
    }, [reference]);

    return (
      <>
        {(['liquid-label', 'garden-label'].includes(qr_data.data.qr_type)) && (
            <div className={styles.fileInputWrap}>
                <FileInput 
                    onFileSelect={handleFileSelected}
                    acceptedFileTypes={'.gif, .jpg, .jpeg, .pdf, .png, .webp'}
                    multiple={true}
                    label={'Upload'}
                    id={'tracker-file-input'}
                    name={'trackerFile'}
                    disabled={qr_data?.data?.tracker?.files?.length > 4}
                />
                <FilesList
                    filesToDisplay={filesToDisplay}
                    fileHelpers={fileHelpers}
                />
            </div>
        )}
        <div className={styles.container}>
            <Fields fields={fields} reference={reference} originalFields={originalFields} />
        </div>
      </>
    );
};
